import React, { useEffect, useState } from 'react';
import { Table, Form, Dropdown, Menu, Checkbox, Select, Button, Modal, message } from 'antd';
import "./PartnerDashboard.css";
import { EllipsisOutlined } from '@ant-design/icons';
import TextArea from 'antd/lib/input/TextArea';
import { render } from '@testing-library/react';

const LanPayoutDashboardList = (props) => {

  const {
    landataSource,
    setLanDatasource,
    partnerAction,
    setPartnerAction,
    handleRadioChange,
    radiostate,
    setRadioState,
    handleCheckboxChange,
    selectedCheckboxes,
    setRemarkComment,
    remarkComment,
    handleQueryRemark,
    pagination,
    onPageChange,
    addQueryOpen,
    setAddQueryOpen,
    downloadAction,
    setDownloadAction,
    recovery,
    setRecovery,
    makerAction,
    setMakerAction

  } = props;

  const [datasource, setDatasource] = useState([]);
  // const [addQueryOpen, setAddQueryOpen] = useState(false);
  const [form] = Form.useForm();

  useEffect(() => {
    setDatasource(landataSource);
  }, [landataSource, radiostate]);


  const handleModalCancel = () => {
    setAddQueryOpen(false);
  }

 

  const handleHeaderMenuClick = (key) => {
    
    switch (key) {
      case 'Query':
       
        setAddQueryOpen(true);

        break;
      case 'AddRemark':
       
        break;
      default:
        
    }
  };

  const handleQueryRemark1 = async () => {
    try {
      

      const res = await handleQueryRemark();
      
      setAddQueryOpen(false);
    } catch (error) {
      console.error("Failed to submit query remark:", error);

    }
  }

  const headerMenu = (
    <Menu
      onClick={({ key }) => handleHeaderMenuClick(key)}
      items={[
        { label: 'Raise Query', key: 'Query' },
        { label: 'Add/ View Remark', key: 'AddRemark' },
      ]}
    />
  );

  const columns = [
    //  ...(partnerAction ?[ 
    //         {
    //           title: 'Check',
    //           dataIndex: 'Check',
    //           key: 'Check',
    //           fixed: 'left',
    //           width: 60,
    //           render: (_, record) => (
    //             <Checkbox
    //               checked={selectedCheckboxes.Check.includes(record)}
    //               onChange={(e) => handleCheckboxChange(e, 'Check', record)}
    //             />
    //           ),
    //         },] :[] ),
    {
      title: 'Applicant Name',
      dataIndex: 'applicantName',
      key: 'applicantName',
      align: 'center',
      width: 190,
    },
    {
      title: 'BRCH_CODE',
      dataIndex: 'partnerCode',
      key: 'partnerCode',
      align: 'center',
      width: 190,

    },
    {
      title: 'DISB_FILE_NO',
      dataIndex: 'lanNo',
      key: 'lanNo',
      align: 'center',
      width: 190,
    },
    {
      title: '1st Disb Amount',
      dataIndex: 'firstDisbAmount',
      key: 'firstDisbAmount',
      align: 'center',
      width: 190,
      render: (_, record) => (record.disbSeq <= 1 ? record.firstDisbAmount : 0)?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Tranche Disb Amount',
      dataIndex: 'disbAmount',
      key: 'disbAmount',
      align: 'center',
      width: 190,
      render: (_, record) => (record.disbSeq > 1 ? record.disbAmount : 0)?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
    },
    {
      title: 'Disbursal Date',
      dataIndex: 'disbDate',
      key: 'disbDate',
      align: 'center',
      width: 190,
    },
    ...(downloadAction || makerAction ? [
      {
        title: 'Credit Amount',
        dataIndex: 'creditAmount',
        key: 'creditAmount',
        align: 'center',
        width:190,
        render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
      }
    ] : []),
    ...(recovery || makerAction ? [
      {
        title: 'Debit Amount',
        dataIndex: 'debitAmount',
        key: 'debitAmount',
        align: 'center',
        width:190,
        render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
      }
    ] : []),
    {
      title: 'Percentage Applied',
      dataIndex: 'percentage',
      key: 'percentage',
      align: 'center',
      width:120,
      render: (value) => value !== undefined && value !== null ? `${value}%` : '-',
    },
     ...(recovery
      ? [
        {
          title: 'Recovery Final Amount',
          dataIndex: 'finaRecoveryAmount',
          key: 'finaRecoveryAmount',
          align: 'center',
          width: 170,
          render: (amount) => amount?.toLocaleString("en-IN", { style: "currency", currency: "INR" }),
        },
      ]
      : []
    ),
    {
      title: 'Status',
      dataIndex: 'lanStatus',
      key: 'lanStatus',
      align: 'center',
      width: 190,
    },
   
    // {
    //   title: 'Regular Cases',
    //   dataIndex: 'RegularCases',
    //   key: 'RegularCases',
    //   align:'center',
    // },
    // {
    //   title: 'On Hold',
    //   dataIndex: 'OnHold',
    //   key: 'OnHold',
    //   align:'center',
    // },
    // {
    //   title: 'Recovery',
    //   dataIndex: 'Recovery',
    //   key: 'Recovery',
    //   align:'center',
    // },
    // {
    //   title: 'Remark',
    //   dataIndex: 'Remark',
    //   key: 'Remark',
    //   align:'center',
    // },
    // { 
    //     title: (
    //         <Dropdown overlay={headerMenu} trigger={['click']}>
    //           <span style={{ cursor: 'pointer' }}>
    //             View <EllipsisOutlined />
    //           </span>
    //         </Dropdown>
    //       ),
    //     dataIndex: 'View',
    //     key: 'View',
    //     align: 'center',
    //     // render : (_,record) =>(
    //     //     <Button className='btn-doc' type="default" onClick={handleDocument}>OTC DOCUMENT</Button>
    //     // )
    //   },

  ];

  const handleChange = (event) => {
    // setAddRemarks(event.target.value);
    const value = event.target.value;
    
    // const words = value.trim().split(/\s+/);
    if (value.length <= 250) {
      
      setRemarkComment(value);
      // setApproveRemarks(value);
    } else {
      
      // setAddRemarks(value.slice(0, 250).join(' '));
      message.error("You can only enter a maximum of 250 characters.");
    }
  }

  return (
    <>
      <Table dataSource={datasource}
        pagination={pagination}
        showSizeChanger={true}
        onChange={(pagination) => {
          // Call the parent's handler if provided
          if (props.onPageChange) {
            props.onPageChange(pagination.current, pagination.pageSize, radiostate);
          }
        }}
        columns={columns} rowKey="key" scroll={{ x: 'max-content', y: 'calc(100vh - 300px)' }} />
      {/* <Modal open={addQueryOpen} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]}  onCancel={handleModalCancel}>
          <Form>
          <Form.Item style={{marginBottom:0}}>
            <TextArea style={{marginTop:20}} name='QueryRemark' onChange={e => setRemarkComment(e.target.value)} placeholder='Please add Query Remark'  autoSize={{ minRows: 3, maxRows: 5 }}>
            </TextArea>
           <Button className='btn-query' onClick={handleQueryRemark1} type="submit">Submit Query</Button>
          </Form.Item>
          </Form>
        </Modal> */}
      <Modal open={addQueryOpen} maskStyle={{ backgroundColor: 'rgba(0, 0, 0, 0.2)' }} footer={[]} onCancel={handleModalCancel}>
        <Form
          form={form}
          onFinish={({ QueryRemark }) => {
            setRemarkComment(QueryRemark);
            handleQueryRemark();
          }}
        >
          <Form.Item
            name="QueryRemark"
            rules={[{ required: true, message: 'Please add Query Remark' },
            {
              validator: (_, value) => {
                if (value && value.split(/\s+/).filter(Boolean).length > 250) {
                  return Promise.reject('Remark cannot exceed 250 words');
                }
                return Promise.resolve();
              }
            }]}
            style={{ marginBottom: 0 }}
          >
            <TextArea
              style={{ marginTop: 20 }}
              placeholder='Please add Query Remark'
              autoSize={{ minRows: 3, maxRows: 5 }}
              onChange={handleChange}  // Add this line to handle input changes
              value={remarkComment}  // Bind the value to the state
            />
          </Form.Item>
          <Button className='btn-query' htmlType="submit" type="primary">
            Submit Query
          </Button>
        </Form>
      </Modal>

    </>
  )

}

export default LanPayoutDashboardList;